export const iconFontAwesomeUsersPeopleSquarePersonConfined = (
	<i className="fa-solid fa-square-person-confined"></i>
);
